import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CheckoutBook } from './checkout';
import { InviteBook } from './invite';
import { OfferBook } from './offer';
import { ExternalSearch } from './external-search';

export function CampaignBookRoutes() {
    return (
        <Routes>
            <Route path=":id" element={<OfferBook />} />
            <Route path=":id/checkout" element={<CheckoutBook />} />
            <Route path=":id/invite" element={<InviteBook />} />
            {/* <Route path=":id/external-search" element={<ExternalSearch />} /> */}
        </Routes>
    );
}
